export default class PackageService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getFormData() {
		return this.apiService.callGet('me/channel_packages/form_data')
	}

	getEntities(params) {
		return this.apiService.callGet('me/channel_packages', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/channel_packages/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/channel_packages', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/channel_packages/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/channel_packages/' + id, params)
	}

	getEntitiesForSelectBox(operatorId, params) {
		return this.apiService.callGet(operatorId+'/channel_packages/simple', params)
	}

	// SEARCH
	searchPackagesByNameOrId(params) {
		return this.apiService.callGet('me/channel_packages_search', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/PackageService.js